module.exports = __webpack_public_path__ + "img/spring.b874ddd4.svg";